export const fragSamplerMask = `
precision mediump float;

uniform sampler2D uSamplers[2];
varying vec2 outTexCoord;
uniform bool uInvertMaskAlpha;

void main ()
{
  vec4 mainColor = texture2D(uSamplers[0], outTexCoord);
  vec4 maskColor = texture2D(uSamplers[1], outTexCoord);

  float alpha = mainColor.a;

  if (!uInvertMaskAlpha)
  {
    alpha *= (maskColor.a);
  }
  else
  {
    alpha *= (1.0 - maskColor.a);
  }

  gl_FragColor = vec4(mainColor.rgb * alpha, alpha);
}
`;
